import { Collapsible } from '../interfaces';
import { ControlledParameter } from './controlled-parameter';
import { UncontrolledTransaction } from './uncontrolled-transaction';
import { AdjustmentType } from './adjustment-type';
import { TbaParameter } from './tba-parameter';

export class AppliedAdjustment implements Collapsible {
  appliedAdjustmentId: number;
  tbaUncontrolledParameter: ControlledParameter;
  uncontrolledTransaction = new UncontrolledTransaction();
  adjustmentType: AdjustmentType;
  adjustmentToParameter: number;
  adjustmentToRangeValue: number;
  tbaParameter: TbaParameter;
  justification: string;
  collapsed: boolean;
}
